<!--
 * @Author: your name
 * @Date: 2022-02-28 11:26:45
 * @LastEditTime: 2022-10-22 14:56:33
 * @LastEditors: pyx 3245266940@qq.com
 * @Description: 电子合同 合同详情
 * @FilePath: \wx-front\src\views\contract\contractDetail.vue
-->
<template>
<div class="wrap">
    <div class="contractBox itemBox fontScN7 fontH3">
        <div class="boxTop rowJb rowAs">
            <div class="title  fontH2 fontScN8">{{detailData.title}}</div>
            <div class="status fontH4 rowJcAc" :class="detailData.status?status[detailData.status].color:''">
            {{ detailData.status?status[detailData.status].text:'' }}
            </div>
        </div>
        
        <div  class="itemLine rowJs">
            <div class="fontScN6 titleName">课程名称：</div>
            <div>{{detailData.courseName}}</div>
        </div>
        <div  class="itemLine"><span class="fontScN6">学员签署截止日期：</span>{{detailData.signatureDeadlineTime}}</div>
        <div  class="itemLine rowJs">
            <div class="fontScN6 titleName">合同备注：</div>
            <div>{{detailData.remark}}</div>
        </div>
    </div>
    <div class="contentBox itemBox fontMcA1 fontH2 textOver" @click="enterContract">
        {{detailData.title}}.pdf
    </div>
    <div class="statusBox itemBox fontH2">
        <div class="flexRow statusItem">
            <div class="imgItem">
                 <img src="../../assets/static/contract/organizationImg.svg" class="bigImg" alt="">
                 <img src="../../assets/static/contract/finishImg.svg" class="smallImg" alt="">
            </div>
            <div class="textItem">
                <div class="fontScN9">{{ campus.split('-')[0] }}</div>
                <div class="rowJb">
                    <div class="stamped greenColor fontH3">已盖章</div>
                    <div class="time fontH4">{{detailData.createTime}}</div>
                </div>
            </div>        
        </div>
        <div class="lineBox"></div>
        <div class="flexRow statusItem">
            <div class="imgItem">
                 <img src="../../assets/static/contract/personImg.svg" class="bigImg" alt="">
                 <img v-if="detailData.status==1" src="../../assets/static/contract/toBeDealImg.svg" class="smallImg" alt="">
                 <img v-else src="../../assets/static/contract/finishImg.svg" class="smallImg" alt="">
            </div>
            <div class="textItem">
                <div class="fontScN9">{{detailData.customerName}}</div>
                <div class="rowJb">
                    <div class="stamped fontH3" :class="detailData.status?flowStatus[detailData.status].color:''">{{ detailData.status?flowStatus[detailData.status].text:'' }}</div>
                    <div class="time fontH4">{{detailData.signatureTime}}</div>
                </div>
            </div>
        </div>
        
    </div>

    <div class="seeBtnBox rowJcAc">
        <div class="seeBtn fontH3 bgcMcA1 rowJcAc fontScW"  @click="enterContract()">{{detailData.status==1?'查看合同并签署':'查看合同'}}</div>
    </div>
</div>
</template>

<script>
import { getContractDetailAPI} from "../../utils/api/contractAPI";
export default {
  name: 'contractDetail',
  data() {
    return {
        status: { //状态map
            1: { color: "waitFor", text: "待我签署" },
            2: { color: "effective", text: "已生效" },
            3: { color: "rejectSign", text: "已拒签" },
        },
        campusCode: "",//校区code
        parentUid: "",//用户id
        campus: "",//校区名
        id:'',//合同id
        detailData:{//详情数据
          status:0
        },
        flowStatus: {//流程里的状态map
            1: { color: "orangeColor", text: "待我签署" },
            2: { color: "greenColor", text: "已签署" },
            3: { color: "greenColor", text: "已签署" },
        },
    };
  },
   computed: {
    },
    watch: {
    },
     beforeRouteLeave(to, from, next) {
            if (to.path == "/signContract") {
            // from.meta.keepAlive = true
            } else {
            this.$bus.$emit("pageEvent", { pageName: "contractDetail", type: "del" });
            // from.meta.keepAlive = false
            }
            next();
        },
  activated() {
    console.log('kk-activated--',this.$route.params)
    if(this.$route.params.id){
      this.id = this.$route.params.id
      this.getContractDetail();
    }
      
        
    },
    deactivated() {
    },
  created() {
    console.log('kk-created--',this.$route.params)
    this.$bus.$emit("pageEvent", { pageName: "contractDetail", type: "add" });
    console.log('kkkk----',this.$route.params.id)
    var selectedCampus = {};
    if (this.$common.getCache("campusItem")) {
      // 判断本地有无校区信息
      var selectedCampus = JSON.parse(this.$common.getCache("campusItem"));
    } else {
      var campusList = JSON.parse(this.$common.getCache("customerAuthList"));
      if (campusList) {
        var selectedCampus = campusList[0];
      }
    }
    this.campus = selectedCampus.campusName;
    this.campusCode = selectedCampus.campusCode;
    this.parentUid = selectedCampus.customerId;
  },
  mounted() {
      this.id = this.$route.params.id
      this.getContractDetail();
  },
  methods: {
    //进去合同签署页面
    enterContract() {
      this.$bus.$emit("pageEvent", { pageName: "signContract", type: "del" });
      this.$router.push({
        name: "SignContract",
        params: { detailData: this.detailData },
      });
    },
    //获取合同详情
    getContractDetail() {
      var obj = {
        customerId: this.parentUid,
        id: this.id,
      };
      getContractDetailAPI(obj)
        .then((res) => {
          if (res.resultCode == 200) {
            console.log("获取合同详情", res.data);
            this.detailData = res.data
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.wrap {  
background: #F5F6F9;
height: 100%;
font-size: 14px;
padding: 0.16rem;
box-sizing: border-box;
}
.contentBox{  
    // height: 231px;
    
    padding: 0.14rem 0.2rem 0.14rem 0.2rem;
    margin-top: 8px;
    box-sizing: border-box;
}
.seeBtnBox{
    width: 100%;
    // height: 64px;
    position: fixed;
    bottom: 0;
    left: 0;
    background: #FFFFFF;
    padding: 8px 16px 8px 16px;
    box-sizing: border-box;
}
.seeBtn{
    width: 100%;
    height: 48px;
    border-radius: 6px;
}
.campusName{
    line-height: 23px;
}

.itemBox{
    width: 100%;
    margin-bottom: 16px;
    border-radius: 0.08rem;
    background: #FFFFFF;
}
.contractBox{
    padding: 0.16rem 0.2rem;
    box-sizing: border-box;
}
.statusBox{
    width: 100%;
    padding: 0.2rem;
    box-sizing: border-box;

}
.imgItem{
    position: relative;
    margin-right: 0.16rem;
}
.bigImg{
    width: 0.4rem;
    height: 0.4rem;
    
}
.smallImg{
    width: 0.16rem;
    height: 0.16rem;
    position: absolute;
    top: 0.26rem;
    left: 0.3rem;
}
.greenColor{
    color: #03BF6D;
}
.orangeColor{
  color: #FA8C16;
}
.statusItem{
    width: 100%;
    position: relative;
}
.textItem{
    width: 100%;
    .time{
        color: #A6AAB8;
    }
}
.lineBox{
    width: 3px;
    height: 28px;
    background: #E8F2FF;
    margin-left: 0.19rem;
    margin-bottom: 6px;
}
.itemLine{
    margin-bottom: 4px;
}
.boxTop {
    margin-bottom: 6px;
    .title {
      font-weight: 500;
      max-width: 2.3rem;
    }
    .status {
      width: 0.6rem;
      height: 24px;
    //   padding: 4px 8px;
      border-radius: 4px;
      box-sizing: border-box;
    //   font-size: 0.12rem;
    }
  }
.titleName{
    min-width: 0.7rem;
}
.waitFor {
  color: #FAAD14;
  background: #FFFBE6;
}
.rejectSign {
  color: #FA3F3F;
  background: #FFF2F0;
}
.effective {
  color: #03BF6D;
  background: #E6FFF0;
}
</style>
